var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.60075 8.18164H6.77344V16.4544C6.77344 17.8602 7.91308 18.9998 9.31889 18.9998H15.6825V17.9892H9.50984C8.45548 17.9892 7.60075 17.1345 7.60075 16.0801V8.18164Z",
    fill: "#404040"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.31836,
    y: 5,
    width: 8.90909,
    height: 11.4545,
    rx: 1.27273,
    stroke: "#2B323B",
    strokeWidth: 0.954545
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyNew);
export default __webpack_public_path__ + "static/media/copy-new.3e7698597857e7fbb635e8384f46d3b6.svg";
export { ForwardRef as ReactComponent };